import { Controller } from "@hotwired/stimulus"

// Stimulus controller wrapping SortableJS for drag-and-drop reordering.
//
// Usage in views:
//   <tbody data-controller="sortable"
//          data-sortable-url-value="/admin/menu_items/reorder">
//     <tr data-sortable-id="1">
//       <td class="sortable-handle"><%= icon('grip') %></td>
//       ...
//     </tr>
//   </tbody>
//
export default class extends Controller {
  static values = {
    url: String,
    handle: { type: String, default: ".sortable-handle" }
  }

  connect() {
    if (typeof Sortable === 'undefined') {
      console.warn("SortableJS not loaded")
      return
    }

    this.sortable = new Sortable(this.element, {
      handle: this.handleValue,
      animation: 150,
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  onEnd(event) {
    if (event.oldIndex === event.newIndex) return

    const ids = Array.from(this.element.children)
      .map(el => el.dataset.sortableId)
      .filter(Boolean)

    if (!this.urlValue || ids.length === 0) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken ? csrfToken.content : '',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ ids: ids })
    }).catch(error => {
      console.error("Reorder failed:", error)
    })
  }
}
